/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */

/** @module core/modules/randomizer/get-id */
import { SEEDS } from '../../../constants/seeds.js';
/**
 * @description Generates and return a random ID.
 * @param {number} [length=10] - Generated ID length.
 * @param {string} [customSeed] - Custom seed to be used for random generation.
 * @returns {string} Generated ID.
 */

function getId(length, customSeed) {
  var seed = customSeed || SEEDS.alphaNum;
  length = length || 10;
  var output = '';

  for (var i = 0; i < length; i++) {
    output += seed.charAt(Math.floor(Math.random() * seed.length));
  }

  return output;
}

export { getId };